"use client";

import {
  SignUpSnackbarEvent,
  useSignUpSnackbarStateMachine,
} from "@faire/retailer-visitor-shared/components/LoggedOutMobileSignUpSnackbar/useSignupSnackbarStateMachine";
import { MobileFixedBanner } from "@faire/retailer-visitor-shared/components/MobileAppSnackbar/MobileFixedBanner";
import { WrappedModal } from "@faire/retailer-visitor-shared/components/MobileAppSnackbar/WrappedModal";
import {
  popSignUp,
  SignUpElement,
  SignUpType,
} from "@faire/retailer-visitor-shared/lib/popSignUp";
import {
  useAssignSettingSignupCTAMobileWebBanner,
  useSettingSignupCTAMobileWebBanner,
} from "@faire/retailer-visitor-shared/settings/useSettingSignupCTAMobileWebBanner";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

export const LoggedOutMobileSignUpSnackbar: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const { isMobile } = useViewport();
  const history = useHistory();
  const { isSignUpSnackbarDisplayable, updateSignUpSnackbarState } =
    useSignUpSnackbarStateMachine();

  const showSignupCTAMobileWebBanner = useSettingSignupCTAMobileWebBanner();
  const assignSettingSignupCTAMobileWebBanner =
    useAssignSettingSignupCTAMobileWebBanner();

  const dismissModal = () => {
    updateSignUpSnackbarState(SignUpSnackbarEvent.DISMISSED);
  };

  const handleCTAClick = () => {
    popSignUp(history, SignUpType.GENERIC, () => {}, {
      element: SignUpElement.SNACKBAR,
      sourceId: "logged_out_mobile_sign_up_snackbar",
    });
    dismissModal();
  };

  useEffect(() => {
    // on dismount, if the user is eligible to see the snackbar
    //   we want to store the state so that the snackbar is shown on next page load
    return () => {
      updateSignUpSnackbarState(SignUpSnackbarEvent.NAVIGATED);
    };
  }, [updateSignUpSnackbarState]);

  const shouldShowSnackbar = isMobile && isSignUpSnackbarDisplayable;

  useEffect(() => {
    if (shouldShowSnackbar) {
      // assign XP when user is eligible to see the snackbar
      assignSettingSignupCTAMobileWebBanner();
    }
  }, [assignSettingSignupCTAMobileWebBanner, shouldShowSnackbar]);

  return (
    <WrappedModal
      ariaHideApp={false}
      bottom={0}
      isOpen={shouldShowSnackbar && showSignupCTAMobileWebBanner}
      showOverlay={false}
    >
      <MobileFixedBanner
        message={strictLocalize({
          defaultMessage: "Signup to unlock wholesale prices for your store",
          description: {
            text: "Banner message asking retailers to signup",
          },
        })}
        ctaText={strictLocalize({
          defaultMessage: "Sign up for free",
          description: {
            text: "CTA for retailers to signup",
          },
        })}
        ctaAction={handleCTAClick}
        closeAction={dismissModal}
        mediumMessageFont
        noIcon
        cornerButton
      />
    </WrappedModal>
  );
};
